// extracted by mini-css-extract-plugin
export default {"wrapper":"Index_wrapper__yGzVJ","studio-wrapper":"Index_studio-wrapper__predG"};